import { getPlatform } from './environment-utils';

// Handle IOS use case with resize event broken.
// We should timeout 500ms before applying the callback.
// You can find why here https://openradar.appspot.com/radar?id=5040881597939712
// Here is someone explaining faster the problem https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
export function onResize(callback: () => void): () => void {
  const iosCallback = () => {
    setTimeout(callback, 50);
  };

  const finalCallback = getPlatform() === 'IOS' ? iosCallback : callback;

  window.addEventListener('resize', finalCallback);

  return finalCallback;
}

export function removeResizeEvent(callback: () => void): void {
  window.removeEventListener('resize', callback);
}
